import ImageUploader from '../../ImageUploader/View'
import useFetchSurveyDetail from '../useFetchSurveyDetail'

const SurveySalesAttachmentsTab: React.FC = () => {
  const { isSurveyLoaded } = useFetchSurveyDetail()

  if (!isSurveyLoaded) {
    return (
      <div className='d-flex justify-content-center py-20'>
        <div className='spinner-border text-primary' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </div>
      </div>
    )
  }

  return (
    <div className='card'>
      <div className='card-header'>
        <div className='card-title fw-bold'>ไฟล์แนบ(ฝ่ายขาย)</div>
      </div>
      <div className='card-body'>
        <ImageUploader variant='inline' category='sales' />
      </div>
    </div>
  )
}

export default SurveySalesAttachmentsTab
